import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import debounce from 'lodash/debounce';
import throttle from 'lodash/throttle';
import { Swipeable } from 'react-swipeable';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

import OPTIONS from '../Options';

import { withAppContext } from '../contexts/app';
import { DesktopUp } from 'shared/Responsive';

import CTAGetStarted from '../components/cta/GetStarted';
//import TestedBy from '../components/sections/TestedBy';
//import Testimonials from './home/Testimonials';
import Features from './home/Features';
import HeroSliderNavigation from './home/HeroSliderNavigation';
import HomeSlide from './home/HomeSlide';

// macosx inertia problem wait 1.3s between changing to the next slide
const HERO_SLIDER_ANIMATION_SPEED = 1300;
const HERO_SLIDES = 4;

class Home extends Component {
  disableChangingSlides = false;

  constructor(props) {
    super(props);

    this.state = {
      heroSliderHeight: undefined,
      slidePaddingTop: 0,
      currentSlideNumber: 1
    };

    this.disableChangingSlides = OPTIONS.home.disableHeroSlider;
    this.handleWindowOnScroll = this.handleWindowOnScroll.bind(this);
    this.handleWindowOnResize = this.handleWindowOnResize.bind(this);
  }

  fixFullViewMobileHeight() {
    const navbarHeight = document.getElementsByClassName('navbar')[0].offsetHeight;
    const heroSliderHeight = window.innerHeight - navbarHeight;

    this.setState({
      heroSliderHeight: heroSliderHeight,
      slidePaddingTop: parseInt(heroSliderHeight * 0.07)
    });
  }

  debouncedSlideToTop = debounce(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, 100);

  handleHeroOnWheel = (event) => {
    const wheelDown = event.deltaY > 0;
    this.handleSliderInteraction(wheelDown);
  }

  handleHeroSwipedLeft = () => {
    this.changeSlide(true);
  }

  handleHeroSwipedRight = () => {
    this.changeSlide(false);
  }

  handleHeroSwipedUp = () => {
    this.handleSliderInteraction(true);
  }

  handleHeroSwipedDown = () => {
    this.handleSliderInteraction(false);
  }

  handleWindowOnResize() {
    this.fixFullViewMobileHeight();
  }

  handleSliderInteraction = (goToNext) => {
    if (OPTIONS.home.disableHeroSlider || this.slideChanging) { return; }

    if (window.pageYOffset === 0) {
      if (goToNext && this.state.currentSlideNumber === HERO_SLIDES) {
        this.scrollToFeatures();
      } else {
        this.changeSlide(goToNext);
      }
    } else if (window.pageYOffset < this.heroSliderSection.clientHeight && !goToNext) {
      this.debouncedSlideToTop();
    }
  }

  changeSlide = (goToNext) => {
    if (this.disableChangingSlides) return;

    this.handleBeforeChange();
    if (goToNext) {
      this.setState((state) => {
        if (state.currentSlideNumber < HERO_SLIDES) {
          return {
            currentSlideNumber: state.currentSlideNumber + 1
          };
        }
      });
    } else {
      this.setState((state) => {
        if (state.currentSlideNumber > 1) {
          return {
            currentSlideNumber: state.currentSlideNumber - 1
          };
        }
      });
    }
  }

  handleWindowOnScroll = throttle(() => {
    if (OPTIONS.home.disableHeroSlider) { return; }

    if (window.pageYOffset === 0) {
      disableBodyScroll(window.document.body);
      // give a little time for to scroll to be disabled
      setTimeout(() => {
        this.disableChangingSlides = false;
      }, 500);
    }
  }, 50)

  handleBeforeChange = () => {
    this.disableChangingSlides = true;
    this.slideChanging = true;

    setTimeout(this.handleAfterChange, HERO_SLIDER_ANIMATION_SPEED);
  }

  handleAfterChange = () => {
    this.disableChangingSlides = false;
    this.slideChanging = false;
  }

  handleNavigationLineClick = (slideNumber) => {
    this.setState({ currentSlideNumber: slideNumber }, this.handleBeforeChange);
  }

  handleImageUpload = (image) => {
    this.props.app.onImageUpload(image);
  }

  scrollToFeatures = () => {
    this.disableChangingSlides = true;
    enableBodyScroll(window.document.body);
    // looks like on mobile firefox this is needed
    setTimeout(() => {
      const element = document.getElementById('features');
      if (element) element.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  }

  componentDidMount() {
    this.fixFullViewMobileHeight();

    window.addEventListener('resize', this.handleWindowOnResize);

    if (OPTIONS.home.disableHeroSlider) { return; }

    window.addEventListener('scroll', this.handleWindowOnScroll);

    //sometimes body scroll is not cleared, some racing conditions, let's clear it periodically
    this.fixBodyScrollIssueInterval = setInterval(() => {
      if (window.pageYOffset > 0 && this.heroSliderSection) {
        enableBodyScroll(window.document.body);
      }
    }, 500);

    if (window.pageYOffset === 0) {
      disableBodyScroll(window.document.body);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleWindowOnScroll);
    window.removeEventListener('resize', this.handleWindowOnResize);

    clearInterval(this.fixBodyScrollIssueInterval);
    clearAllBodyScrollLocks();
  }

  render() {
    const { currentSlideNumber } = this.state;

    const heroSliderStyle = {
      height: this.state.heroSliderHeight
    };

    const sliderStyle = {
      transform: `translateX(-${(currentSlideNumber-1)*100}%)`
    };

    const homeSlideStyle = {
      paddingTop: this.state.slidePaddingTop
    };

    return (
      <div className="home-view" onWheel={(e) => this.handleHeroOnWheel(e)}>
        <Swipeable
          onSwipedLeft={this.handleHeroSwipedLeft}
          onSwipedRight={this.handleHeroSwipedRight}
          onSwipedUp={this.handleHeroSwipedUp}
          onSwipedDown={this.handleHeroSwipedDown}
        >
          <section
            className={cx('hero-slider', { disabled: OPTIONS.home.disableHeroSlider })}
            style={heroSliderStyle}
            ref={s => this.heroSliderSection = s}
          >
            <HeroSliderNavigation slides={HERO_SLIDES} currentSlide={currentSlideNumber} onLineClick={this.handleNavigationLineClick} />

            <div className="slider" style={sliderStyle}>
              <HomeSlide active={currentSlideNumber === 1} number={1} style={homeSlideStyle} onImageUpload={this.handleImageUpload} onLeaveButtonClick={this.scrollToFeatures}>
                <h1>
                  Instant second opinion for skin. <DesktopUp><br /></DesktopUp>Powered by AI.
                </h1>
                <p>
                  Snap a photo to screen for thousands of skin conditions and symptoms<span className="desktop"> using artificial intelligence</span>.
                </p>
              </HomeSlide>

              <HomeSlide active={currentSlideNumber === 2} number={2} style={homeSlideStyle} onImageUpload={this.handleImageUpload} onLeaveButtonClick={this.scrollToFeatures}>
                <h2>
                  It’s as simple as taking a photo.
                </h2>
                <p>
                  Follow our instructions to take or upload a photo of skin. We also support dermoscopic photos.
                </p>
              </HomeSlide>

              <HomeSlide active={currentSlideNumber === 3} number={3} style={homeSlideStyle} onImageUpload={this.handleImageUpload} onLeaveButtonClick={this.scrollToFeatures}>
                <h2>
                  We’ll analyze the photo.
                </h2>
                <p>
                  Our technology has learned from millions of photos how to identify skin conditions.
                </p>
              </HomeSlide>

              <HomeSlide active={currentSlideNumber === 4} number={4} style={homeSlideStyle} onImageUpload={this.handleImageUpload} onLeaveButtonClick={this.scrollToFeatures}>
                <h2>
                  Get answers, instantly.
                </h2>
                <p>
                  We provide you with a differential to help you narrow down possible conditions.
                </p>
              </HomeSlide>
            </div>
          </section>
        </Swipeable>
        <Features />
        {/*<Testimonials />*/}
        {/*<TestedBy title="Tested by doctors at:" />*/}
        <CTAGetStarted />
      </div>
    );
  }
}

Home.propTypes = {
  app: PropTypes.object.isRequired
};

export default withAppContext(Home);
